import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { greateAmericanTypeOfOperationCourier, greateAmericanTypeOfOperationHouseholdGoods } from '../../constants/greateAmerican';
import { TagTypeEnum, YearsInBusinessEnum } from '../../shared/generated';
export var getGreatAmericanTypeOfRemovalJovList = function getGreatAmericanTypeOfRemovalJovList(allList, config) {
  var list = _toConsumableArray(allList);

  if (config !== null && config !== void 0 && config.isFastTrack) {
    var _config$declarationQu, _config$declarationQu2;

    if ((config === null || config === void 0 ? void 0 : (_config$declarationQu = config.declarationQuestions) === null || _config$declarationQu === void 0 ? void 0 : (_config$declarationQu2 = _config$declarationQu['enter_customer_house_carry_heavy_items']) === null || _config$declarationQu2 === void 0 ? void 0 : _config$declarationQu2.truelyValue) === true) {
      list = list.filter(function (item) {
        return [greateAmericanTypeOfOperationHouseholdGoods].includes(item.value);
      });
    } else {
      list = list.filter(function (item) {
        return [greateAmericanTypeOfOperationCourier, greateAmericanTypeOfOperationHouseholdGoods].includes(item.value);
      });
    }
  }

  return list;
};
export var judgeGAQuoteMissingLossReport = function judgeGAQuoteMissingLossReport(data) {
  var _ref = (data === null || data === void 0 ? void 0 : data.payload) || {},
      labels = _ref.labels,
      yearsInBusiness = _ref.yearsInBusiness;

  var hasMissingLossReport = !!labels && !!labels[TagTypeEnum.MISSING_LOSS_REPORT];
  var isYears3Or5OrOver5 = yearsInBusiness === YearsInBusinessEnum.YIB0 || yearsInBusiness === YearsInBusinessEnum.YIB4;
  var noTags = !labels || Object.keys(labels).length === 0;
  var noLossReportCollected = !!labels && !labels[TagTypeEnum.LOSS_REPORT_COLLECTED];
  return hasMissingLossReport || isYears3Or5OrOver5 && (noTags || noLossReportCollected);
};
export var judgeGAQuoteMissingVIN = function judgeGAQuoteMissingVIN(data) {
  var _ref2 = (data === null || data === void 0 ? void 0 : data.payload) || {},
      labels = _ref2.labels;

  return !!labels && !!labels[TagTypeEnum.MISSING_VIN];
};